import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { appInfo, userInfo } from ".././authConfig";
import appInfoDefaults from "../../resources/app_info.json";

type ResourceObject = Record<string, unknown>;

const isPlainObject = (value: unknown): value is ResourceObject => typeof value === "object" && value !== null && !Array.isArray(value);

const isUnsafeMergeKey = (key: string): boolean => key === "__proto__" || key === "constructor" || key === "prototype";

const mergeWithFallback = (fallback: unknown, primary: unknown): unknown => {
    if (Array.isArray(fallback)) {
        return Array.isArray(primary) ? primary : fallback;
    }

    if (isPlainObject(fallback)) {
        const primaryObj: ResourceObject = isPlainObject(primary) ? primary : Object.create(null);
        const merged = Object.create(null) as ResourceObject;
        const keys = new Set<string>([...Object.keys(fallback), ...Object.keys(primaryObj)]);

        keys.forEach(key => {
            if (isUnsafeMergeKey(key)) return;
            merged[key] = mergeWithFallback((fallback as ResourceObject)[key], primaryObj[key]);
        });
        return merged;
    }

    return primary === undefined || primary === null ? fallback : primary;
};

const commonEn = mergeWithFallback((appInfoDefaults as any)?.commonEn ?? {}, appInfo?.commonEn ?? {}) as ResourceObject;
const commonJa = mergeWithFallback((appInfoDefaults as any)?.commonJa ?? {}, appInfo?.commonJa ?? {}) as ResourceObject;

// the translations
const resources = {
    en: {
        common: commonEn
    },
    ja: {
        common: commonJa
    }
};

i18n.use(initReactI18next).init({
    resources,
    lng: userInfo.locale || "ja",
    fallbackLng: "ja",

    interpolation: {
        escapeValue: false // react already safes from xss
    },
    defaultNS: "common"
});

export default i18n;
